import axios from 'axios';
import qs from 'qs';
import _ from 'lodash';
import { APIService } from '@/services/APIService';

export class api_dds_experiment extends APIService {
  constructor(api_base_url, is_dummy = false) {
    super(api_base_url);
    this.is_dummy = is_dummy;
  }
  getSolutionConfig(school_code, experiment, equipment_id) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/getSolutionConfig.php`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_code: school_code,
          experiment: experiment,
          equipment_id: equipment_id
        }
      }).then(response => response.data);
    }
  }
  getSetupPhoto(school_code, experiment, equipment_id) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/getSetupPhoto.php`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_code: school_code,
          experiment: experiment,
          equipment_id: equipment_id
        }
      }).then(response => response.data);
    }
  }
  getLabManual(school_code, experiment, equipment_id) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/getLabManual.php`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_code: school_code,
          experiment: experiment,
          equipment_id: equipment_id
        }
      }).then(response => response.data);
    }
  }
  getExperimentVideoDemo(school_code, experiment, equipment_id) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/getExperimentVideoDemo.php`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_code: school_code,
          experiment: experiment,
          equipment_id: equipment_id
        }
      }).then(response => response.data);
    }
  }
  checkBookingEnd(booking_id, school_code, experiment, equipment_id) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/checkBookingEnd.php?`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          booking_id: booking_id,
          school_code: school_code,
          experiment: experiment,
          equipment_id: equipment_id
        }
      }).then(response => response.data);
    }
  }
  checkOverride(booking_id, school_code, experiment, equipment_id) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/checkOverride.php`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          booking_id: booking_id, 
          school_code: school_code,
          experiment: experiment,
          equipment_id: equipment_id
        }
      }).then(response => response.data);
    }
  }
  checkGroupSlotOverride(slot_id, school_code, experiment, equipment_id) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/checkGroupSlotOverride.php`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          slot_id: slot_id, 
          school_code: school_code,
          experiment: experiment,
          equipment_id: equipment_id
        }
      }).then(response => response.data);
    }
  }
  setChart(school_code, experiment, equipment_id, device_id, chart) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/setChart.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school_code', school_code);
    bodyFormData.set('experiment', experiment);
    bodyFormData.set('equipment_id', equipment_id);
    bodyFormData.set('device_id', device_id);
    bodyFormData.set('chart', chart);
    var dummy_response = {
      status: "success"
    };

    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios({
        method: 'post',
        url: url,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })
        .then(response => response.data);
    }
  }
  getChart(session_token, role, school_code, experiment, equipment_id, device_id) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/getChart.php`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          session_token: session_token,
          role: role,
          school_code: school_code,
          experiment: experiment,
          equipment_id: equipment_id,
          device_id: device_id,
        }
      }).then(response => response.data);
    }
  }
  getChartMultiple(session_token, role, school_code, experiment, equipment_id, device_id, no_of_data, data1, data2) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/getChartMultiple.php`;
    var dummy_response = {
      value: []
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          session_token: session_token,
          role: role,
          school_code: school_code,
          experiment: experiment,
          equipment_id: equipment_id,
          device_id: device_id,
          no_of_data: no_of_data,
          data1: data1,
          data2: data2
        }
      }).then(response => response.data);
    }
  }
  clearChartMultiple(school_code, experiment, equipment_id, device_id, no_of_data, data) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/clearChartMultiple.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school_code', school_code);
    bodyFormData.set('experiment', experiment);
    bodyFormData.set('equipment_id', equipment_id);
    bodyFormData.set('device_id', device_id);
    bodyFormData.set('no_of_data', no_of_data);
    bodyFormData.set('data', data);
    var dummy_response = {
      status: "success"
    };

    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios({
        method: 'post',
        url: url,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      }).then(response => response.data);
    }
  }
  setValue(school_code, experiment, equipment_id, device_id, value) {
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/setValue.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('school_code', school_code);
    bodyFormData.set('experiment', experiment);
    bodyFormData.set('equipment_id', equipment_id);
    bodyFormData.set('device_id', device_id);
    bodyFormData.set('value', value);
    var dummy_response = {
      status: "success"
    };

    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios({
        method: 'post',
        url: url,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })
        .then(function (response) {
          //handle success
          console.log(response);
        });
    }
  }
  getValue(session_token, role, school_code, experiment, equipment_id, device_id, is_group_experiment = null) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/getValue.php`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {

      return axios.get(url, {
        params: {
          session_token: session_token,
          role: role,
          school_code: school_code,
          experiment: experiment,
          equipment_id: equipment_id,
          device_id: device_id,
          is_group_experiment: is_group_experiment
        }
      }).then(response => response.data);
    }
  }
  getGroupValue(session_token, role, school_code, experiment, equipment_id, device_id, session_type) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/getGroupValue.php`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {

      return axios.get(url, {
        params: {
          session_token: session_token,
          role: role,
          school_code: school_code,
          experiment: experiment,
          equipment_id: equipment_id,
          device_id: device_id,
          session_type: session_type,
        }
      }).then(response => response.data);
    }
  }
  setCommand(session_token, role, school_code, experiment, equipment_id, device_id, command) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/setCommand.php`;
    //const url = `${this.api_base_url}/api/iot/bluerhinos/phpmqtt/src/publish.php`;
    var bodyFormData = new FormData();
    bodyFormData.set('session_token', session_token);
    bodyFormData.set('role', role);
    bodyFormData.set('school_code', school_code);
    bodyFormData.set('experiment', experiment);
    bodyFormData.set('equipment_id', equipment_id);
    bodyFormData.set('device_id', device_id);
    bodyFormData.set('command', command);
    
    var dummy_response = {
      status: "success"
    };

    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios({
        method: 'post',
        url: url,
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      })
        .then(response => response.data);
    }
  }
  downloadZipExperimentData(school_code, experiment, equipment_id, device_id) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/downloadZipExperimentData.php`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_code: school_code,
          experiment: experiment,
          equipment_id: equipment_id,
          device_id: device_id
        }
      }).then(response => response.data);
    }
  }
  downloadZipGroupExperimentData(school_code, experiment, equipment_id, device_id, ref) {    //user side
    var self = this;
    const url = `${this.api_base_url}/api/iot/experiment/downloadZipGroupExperimentData.php`;
    var dummy_response = {
      value: [
      ]
    };
    if (self.is_dummy) {
      return new Promise(function (resolve) { setTimeout(function () { resolve(dummy_response) }, 1000); });
    } else {
      return axios.get(url, {
        params: {
          school_code: school_code,
          experiment: experiment,
          equipment_id: equipment_id,
          device_id: device_id,
          ref: ref
        }
      }).then(response => response.data);
    }
  }
}
